import { RichText as CssModulesRichText, RichTextProps } from '@sunwebgroup/uds-ui/rich-text'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/rich-text' instead.
 */
export default Object.assign(
  styled(CssModulesRichText)<RichTextProps>``,
  { displayName: 'RichText' },
)
